import { StopPayment } from '@treasury/domain/stop-payments';
import { LabeledList, TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/tm-labeled-list';
import { formatUsdCurrency } from '@treasury/utils';
import { format } from 'date-fns';
import { css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

export const tagName = 'readonly-stop-payment';
@customElement(tagName)
export class ReadonlyStopPayment extends TmBaseComponent {
    @property({ type: Object })
    public stopPayment!: StopPayment;

    @property({ type: Boolean })
    public isEdit = false;

    private get labeledList() {
        if (this.stopPayment.checkNumberType === 'range') {
            return new LabeledList(
                {
                    account: this.stopPayment.account?.accountDisplayLabel,
                    checkNumbers: this.stopPayment.checkNumbers.join(' - '),

                    remarks: this.stopPayment.remarks,
                },
                ['account', 'checkNumbers', 'remarks'],
                {
                    checkNumbers: 'Check Number(s)',
                }
            );
        }
        return new LabeledList(
            {
                account: this.stopPayment.account?.accountDisplayLabel,
                checkNumbers: this.stopPayment.checkNumbers.join(' - '),
                checkDate: html`<div>
                    ${this.stopPayment.checkDate
                        ? format(this.stopPayment.checkDate, 'MM/dd/yyyy')
                        : html`<div class="text-tertiary text-left py-1 max-w-full break-all">
                              none
                          </div>`}
                </div>`,
                checkAmount: html`<div>
                    ${this.stopPayment.checkAmount
                        ? formatUsdCurrency(this.stopPayment.checkAmount)
                        : html`<div class="text-tertiary text-left py-1 max-w-full break-all">
                              none
                          </div>`}
                </div>`,
                payee: this.stopPayment.payee,
                remarks: this.stopPayment.remarks,
            },
            ['account', 'checkNumbers', 'checkDate', 'checkAmount', 'payee', 'remarks'],
            {
                checkNumbers: 'Check Number(s)',
            }
        );
    }

    protected renderStatus() {
        if (!this.stopPayment.status) {
            return nothing;
        }
        return html`<div class="flex justify-end px-2 py-2">
            <jhd-status .status=${this.stopPayment.status} showLabel></jhd-status>
        </div>`;
    }

    protected render() {
        return html`
            ${this.renderStatus()}
            <tm-labeled-list .list=${this.labeledList}></tm-labeled-list>
        `;
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: block;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: ReadonlyStopPayment;
    }
}
